import { IconButton, Modal, Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { Column, FormWrapper, ModalBody, Row } from "./customerSettings.styled";
import { ButtonStyled } from "components/buttons/buttons.styled";
import { Color } from "config/colors";
import { Text } from "components/Typography/text.styled";
import React, { useState } from "react";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";
import { CompanyCustomer, CompanyCustomerProduct } from "model/Company";
import { FontFamily } from "config/font";
import { AddCustomerServiceForm } from "./addCustomerServiceForm.component";
import { Api } from "services/api/api.service";
import { useTranslation } from "react-i18next";
import { AttachMoney } from "@material-ui/icons";

type Props = {
  setShowCustomerModal: React.Dispatch<React.SetStateAction<boolean>>;
  showCustomerModal: boolean;
  customer?: CompanyCustomer;
  setCustomers: React.Dispatch<CompanyCustomer[]>;
};

export const CustomerModal: React.FC<Props> = ({
  setShowCustomerModal,
  showCustomerModal,
  customer,
  setCustomers
}) => {
  const [showAddCustomerProduct, setShowAddCustomerProduct] = useState(false);
  const [companyState, companyActions] = useCompanyStore();
  const { t } = useTranslation();

  const onSaveProduct = (product: CompanyCustomerProduct) => {
      let companyId = companyState.company?.id;
      if (companyId) {
        Api()
        .company
        .addCompanyCustomerProduct(companyId, product)
        .then((result: any) => {
          let product: CompanyCustomerProduct = result.data;
          if (customer?.agreements && customer.agreements[0].products) {
            let stored = customer.agreements[0].products;
            customer.agreements[0].products = [... stored, product]
          }
          
          Api()
            .company
            .getCompanyCustomers(companyId)
            .then((result) => {
              setCustomers(result.data);
            })
            .catch(err => console.error(err));
        })
        .catch(err => console.error(err));
      }
    }

  return <>
  <Modal title={customer?.name} open={showCustomerModal}
      onClose={() => {
        setShowCustomerModal(false);
      }}>
    
    <ModalBody style={{width: '70%'}}>
      <Row>
        <Column>
          <Text style={{fontFamily: FontFamily.MontserratSemiBold, fontSize: '1.5rem'}}>{customer?.name}</Text>
        </Column>
      </Row>

      <Row style={{paddingLeft: '1rem'}}>
        <Column>
          <Text style={{fontFamily: FontFamily.MontserratSemiBold, fontSize: '1rem'}}>{t('CompanyCustomers.CustomerInformation')}</Text>
        </Column>
      </Row>
      <Row style={{paddingLeft: '1rem'}}>
        <Column style={{fontFamily: FontFamily.MontserratRegular, fontSize: '0.8rem'}}>{t('CompanyCustomers.Name')}: {customer?.name}</Column>
      </Row>
      <Row style={{paddingLeft: '1rem'}}>
        <Column style={{fontFamily: FontFamily.MontserratRegular, fontSize: '0.8rem'}}>{t('CompanyCustomers.OrganizationNumber')}: {customer?.organizationNumber}</Column>
      </Row>
      <Row style={{paddingLeft: '1rem'}}>
        <Column style={{fontFamily: FontFamily.MontserratRegular, fontSize: '0.8rem'}}>{t('CompanyCustomers.Contact')}: {customer?.contact}</Column>
      </Row>


      <Row style={{paddingLeft: '1rem'}}>
          <Column>
            <Text style={{fontFamily: FontFamily.MontserratSemiBold, fontSize: '1rem'}}>{t('CompanyCustomers.Products')}</Text>
          </Column>
      </Row>
      <Row style={{paddingLeft: '1rem', marginTop: -20}}>
        <Column>
          <Text style={{fontFamily: FontFamily.MontserratRegular, fontSize: '0.75rem', cursor: 'pointer'}} onClick={() => {
            let customerId = customer?.id;
            if (customer && customerId) {
              setShowAddCustomerProduct(true);
            }
          }}>{t('CompanyCustomers.AddProduct')}</Text>
        </Column>
      </Row>
      <Table style={{marginBottom: 20}} size="small" aria-label="purchases">
        <TableHead>
          <TableRow>
            <TableCell style={{ fontFamily: FontFamily.MontserratRegular }}>{t('CompanyCustomers.Title')}</TableCell>
            <TableCell style={{ fontFamily: FontFamily.MontserratRegular }}>{t('CompanyCustomers.Price')}</TableCell>
            <TableCell style={{ fontFamily: FontFamily.MontserratRegular }}>{t('CompanyCustomers.OvertimeCompensation')}</TableCell>
            <TableCell style={{ fontFamily: FontFamily.MontserratRegular }}>{t('CompanyCustomers.CompensationType')}</TableCell>
            <TableCell style={{ fontFamily: FontFamily.MontserratRegular }}>{t('CompanyCustomers.StartDate')}</TableCell>
            <TableCell style={{ fontFamily: FontFamily.MontserratRegular }}>{t('CompanyCustomers.EndDate')}</TableCell>
            <TableCell style={{ fontFamily: FontFamily.MontserratRegular }}>{t('CompanyCustomers.Comment')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>

          { customer?.agreements && customer.agreements[0].products?.map((product: CompanyCustomerProduct) => (
            <TableRow key={product.id}>
              <TableCell style={{ fontFamily: FontFamily.MontserratRegular }} component="th" scope="row">
                {product.title}
              </TableCell>
              <TableCell style={{ fontFamily: FontFamily.MontserratRegular }} component="th" scope="row">
                {product.price}
              </TableCell>
              <TableCell style={{ fontFamily: FontFamily.MontserratRegular }}>{product.overtimeRate}</TableCell>
              <TableCell style={{ fontFamily: FontFamily.MontserratRegular }}>{product.productType.toString() === 'Fixed' ? 'Fast ersättning': 'Timersättning'}</TableCell>
              <TableCell style={{ fontFamily: FontFamily.MontserratRegular }}>
                {
                  (product.startDate as unknown as string).split('T')[0].startsWith('0001') ? '-' : (product.startDate as unknown as string).split('T')[0]
                }
              </TableCell>
              <TableCell style={{ fontFamily: FontFamily.MontserratRegular }}>
                {
                  (product.endDate as unknown as string).split('T')[0].startsWith('0001') ? '-' : (product.endDate as unknown as string).split('T')[0]
                }
              </TableCell>
              <TableCell style={{ fontFamily: FontFamily.MontserratRegular }}>{product.comment}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <FormWrapper>
      <Row style={{marginTop: 20}}>
        <Column>
          <ButtonStyled fullWidth backgroundColor={Color.MidnightBlue} onClick={() => setShowCustomerModal(false)}>
            {t('General.Close')}
          </ButtonStyled>
        </Column>
        <Column>
        </Column>
      </Row>
      </FormWrapper>
    </ModalBody>
  </Modal>

      <AddCustomerServiceForm
        customerId={customer?.id}
        customer={customer}
        setShowAddCustomerProductForm={setShowAddCustomerProduct}
        showAddCustomerServiceForm={showAddCustomerProduct}
        saveProduct={product => onSaveProduct(product)}
        />
  </>
}